import moment from 'moment';

export const tribeSortOptions = {
  monthly: { asc: 'MONTHLY_MESSAGES_COUNT_ASC', desc: 'MONTHLY_MESSAGES_COUNT_DESC' },
  claims: { asc: 'LAST_CLAIM_DATE_ASC', desc: 'LAST_CLAIM_DATE_DESC' },
  claimsCount: { asc: 'CLAIMS_COUNT_ASC', desc: 'CLAIMS_COUNT_DESC' },
  game: { asc: 'GAME_NAME_ASC', desc: 'GAME_NAME_DESC' },
  id: { asc: 'ID_ASC', desc: 'ID_DESC' },
};

const readString = (value: unknown) => (typeof value === 'string' ? value : '');

const readNumber = (value: unknown) => {
  const text = readString(value).trim();
  const number = Number(text);
  return text && Number.isFinite(number) && number >= 0 ? number : undefined;
};

const readDate = (value: unknown) => {
  const text = readString(value);
  return text && moment(text, moment.ISO_8601, true).isValid() ? text : undefined;
};

export const parseTribesFilters = (query: Record<string, unknown>) => ({
  sort: Object.values(tribeSortOptions).some(
    ({ asc, desc }) => query.sort === asc || query.sort === desc,
  )
    ? String(query.sort)
    : tribeSortOptions.monthly.desc,
  tribeName: readString(query.tribeName),
  url: readString(query.url),
  owner: readString(query.owner),
  member: readString(query.member),
  game: readString(query.game),
  isBlocked: query.isBlocked === 'true',
  hasClaims: query.hasClaims === 'true' ? true : query.hasClaims === 'false' ? false : undefined,
  membersMin: readNumber(query.membersMin),
  membersMax: readNumber(query.membersMax),
  createdFrom: readDate(query.createdFrom),
  createdTo: readDate(query.createdTo),
});

export type TribesFiltersValue = ReturnType<typeof parseTribesFilters>;

export const parseTribeMembersFilters = (query: Record<string, unknown>) => ({
  nickname: readString(query.nickname),
});

export type TribeMembersFiltersValue = ReturnType<typeof parseTribeMembersFilters>;
